module.exports = __webpack_public_path__ + "static/media/logo-hq-now.f49eb768.svg";